@if (userState.loading$ | async) {
  <div
    style="width: 100vw; height: 100vh; z-index: 1000; pointer-events: none"
    class="flex-row justify-center pos-abs">
    <app-spinner></app-spinner>
  </div>
}

<div
  cdkScrollable
  class="app-root-wrapper scroll-block">
  <router-outlet></router-outlet>
</div>
